import qs from 'qs';

export default (params) => {
    params.filter = JSON.stringify(params.filter)
    return qs.stringify(params)
}
